/* archive-repair-ui.js — the page for /archive-repair.
 *
 * Shape of the tool, and why:
 *
 *  1. DIAGNOSIS FIRST, ALWAYS FREE. Telemetry on the sibling extractor showed 93
 *     of 97 errors in 30 days were "this archive will not open", and the message
 *     users got was "this file is not a supported archive" — true and useless.
 *     Naming the actual fault ("the download stopped at 60 %", "this is an HTML
 *     error page", "it is a RAR wearing a .zip name") is often the whole answer,
 *     so it never touches the daily counter.
 *  2. REPAIR BILLS ONLY ON DELIVERY, per SOURCE ARCHIVE. Re-saving the same
 *     rescue, or repairing the same file again today, is free.
 *  3. EVERY FILE CARRIES ITS VERDICT. Recovered bytes are labelled verified /
 *     unverified / partial / damaged, because a repair tool that hands back
 *     plausible garbage is worse than one that admits defeat — 7-Zip emits five
 *     junk files for one of the committed fixtures.
 *
 * Save paths are the extractor's, deliberately: File System Access streams entries
 * straight to a folder (bounded memory, any archive size), otherwise the files are
 * packed into one ZIP in memory.
 */
(function () {
  'use strict';
  var SLUG = 'archive-repair';
  var T = window.__ARF_T || {};
  function L(k, vars) {
    var s = T[k] || k;
    if (vars) for (var v in vars) s = s.replace(new RegExp(':' + v, 'g'), vars[v]);
    return s;
  }

  /* Only the whitelisted envelopes reach the server: a custom event type is
   * accepted by the endpoint and then silently dropped, which is how the sibling
   * archive tool ran for a month with zero telemetry rows. */
  function raw(type, data) {
    try { if (window.__ae) window.__ae(type, Object.assign({ slug: SLUG, tool: SLUG }, data || {})); } catch (e) {}
  }
  function ae(action, data) { raw('tool_event', Object.assign({ action: action }, data || {})); }
  function stage(name, data) { raw('tool_stage', Object.assign({ stage: name }, data || {})); }
  function complete(data) { raw('tool_complete', data || {}); }
  function failed(reason, data) { raw('tool_error', Object.assign({ reason: reason }, data || {})); }
  function toast(m, t) { try { if (window.__toast) window.__toast(m, t || 'info'); } catch (e) {} }

  var WORKER_URL = window.__ARCHIVE_REPAIR_WORKER_URL || '/js/archive/archive-repair-worker.js';
  function vh(key) { var h = (window.__VENDOR_HASHES || {})[key]; return h ? ('?v=' + h) : ''; }
  var JS_URL = '/vendor/7z-wasm/7zz.es6.js' + vh('sevenZipJs');
  var WASM_URL = '/vendor/7z-wasm/7zz.wasm' + vh('sevenZipWasm');

  // ───────────────────────────── worker client ─────────────────────────────────
  function Client() { this._w = null; this._seq = 0; this._pending = {}; }
  Client.prototype._ensure = function () {
    if (this._w) return;
    var self = this;
    /* Firefox 68 (Sentry HG/HF) модульный воркер НЕ отвергает: он стартует и
       падает на первом `import` — SyntaxError в window.onerror, а человеку
       «worker_crash». Спрашиваем движок ДО создания; общий пробник в layout
       сам говорит человеку и пишет телеметрию, нам остаётся честно остановиться. */
    if (typeof window !== 'undefined' && window.__requireModuleWorker && !window.__requireModuleWorker()) {
      var tooOld = new Error('module_worker_unsupported'); tooOld.code = 'MODULE_WORKER_UNSUPPORTED'; throw tooOld;
    }
    this._w = new Worker(WORKER_URL, { type: 'module' });
    this._w.onmessage = function (ev) {
      var d = ev.data || {};
      var p = self._pending[d.id];
      if (!p) return;
      if (d.stream) { if (p.on) p.on(d); return; }
      delete self._pending[d.id];
      if (d.ok) p.resolve(d.result);
      else { var e = new Error((d.error && d.error.message) || 'worker_error'); e.code = d.error && d.error.code; p.reject(e); }
    };
    this._w.onerror = function (e) {
      // The tool takes the failure (every pending call rejects with worker_crash and the page
      // says so); uncancelled it would also reach window.onerror — the shared toast, Sentry.
      if (e && e.preventDefault) e.preventDefault();
      var ids = Object.keys(self._pending);
      for (var i = 0; i < ids.length; i++) { self._pending[ids[i]].reject(new Error('worker_crash: ' + (e.message || ''))); delete self._pending[ids[i]]; }
    };
  };
  Client.prototype.call = function (op, payload, onStream) {
    this._ensure();
    var self = this, id = ++this._seq;
    return new Promise(function (resolve, reject) {
      self._pending[id] = { resolve: resolve, reject: reject, on: onStream };
      self._w.postMessage(Object.assign({ id: id, op: op, jsUrl: JS_URL, wasmUrl: WASM_URL }, payload));
    });
  };
  Client.prototype.cancel = function () { if (this._w) this._w.postMessage({ op: 'cancel' }); };
  Client.prototype.kill = function () {
    if (!this._w) return;
    this._w.terminate(); this._w = null;
    var ids = Object.keys(this._pending);
    for (var i = 0; i < ids.length; i++) { this._pending[ids[i]].reject(new Error('cancelled')); delete this._pending[ids[i]]; }
  };
  var client = new Client();

  // ─────────────────────────────── helpers ─────────────────────────────────────
  function fmtSize(n) {
    if (!n && n !== 0) return '';
    var u = ['B', 'KB', 'MB', 'GB', 'TB'], i = 0, v = n;
    while (v >= 1024 && i < u.length - 1) { v /= 1024; i++; }
    return (i === 0 ? v : v.toFixed(v < 10 ? 1 : 0)) + ' ' + (T['unit_' + u[i].toLowerCase()] || u[i]);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function el(sel, root) { return (root || document).querySelector(sel); }

  /* Split archives arrive as name.7z.001 / .002 / … — one archive, several files.
   * Anything else the user dropped is a separate job (the batch lane). */
  function groupPicked(files) {
    var jobs = [], vols = {};
    for (var i = 0; i < files.length; i++) {
      var f = files[i];
      // `name.7z.001` … and WinRAR's `name.partN.rar` are both one archive in parts
      var m = String(f.name).match(/^(.*)\.(\d{3,})$/);
      var rm = m ? null : String(f.name).match(/^(.*)\.part(\d+)\.rar$/i);
      if (m) (vols[m[1]] = vols[m[1]] || []).push({ file: f, idx: parseInt(m[2], 10), pat: m[1] + '.%0' + m[2].length + 'd' });
      else if (rm) (vols[rm[1] + '|rar'] = vols[rm[1] + '|rar'] || []).push({ file: f, idx: parseInt(rm[2], 10), pat: rm[1] + '.part%d.rar' });
      else jobs.push({ name: f.name, files: [f] });
    }
    for (var base in vols) {
      var set = vols[base].sort(function (a, b) { return a.idx - b.idx; });
      /* Name the gap. "Данные повреждены" on a torrent set that is simply missing
       * part 3 sends the user hunting for a repair that cannot help — what they
       * need is that one file. Naming it turns a dead end into an errand. */
      var missing = [];
      for (var k = set[0].idx; k <= set[set.length - 1].idx; k++) {
        if (!set.some(function (x) { return x.idx === k; })) missing.push(nameOfPart(set[0].pat, k));
      }
      jobs.push({
        name: set[0].file.name,
        files: set.map(function (x) { return x.file; }),
        volumes: set.length,
        missingParts: missing,
      });
    }
    return jobs;
  }

  function nameOfPart(pat, n) {
    return String(pat).replace(/%0(\d)d/, function (_, w) {
      var s = String(n);
      while (s.length < parseInt(w, 10)) s = '0' + s;
      return s;
    }).replace('%d', String(n));
  }

  // ──────────────────────────────── state ──────────────────────────────────────
  var jobs = [];          // [{name, files, report, items:Map, status}]
  var current = -1;
  var busy = false;
  var root, wsEl, emptyEl, queueEl, cardsEl, resetBtn;

  function statusChip(s) {
    var cls = { ok: 'arf-ok', sound: 'arf-sound', resynced: 'arf-sound', partial: 'arf-partial', damaged: 'arf-bad' }[s] || 'arf-sound';
    return '<span class="arf-chip ' + cls + '" title="' + esc(L('status_' + s + '_hint')) + '">' + esc(L('status_' + s)) + '</span>';
  }

  // ─────────────────────────────── rendering ───────────────────────────────────
  function verdictOf(report) {
    // This browser cannot start the engine at all (no module workers): not a verdict on the file.
    if (report.kind === 'engine') return { tone: 'bad', text: (window.__requireModuleWorker && window.__requireModuleWorker.text) || L('issue_cannot_open') };
    if (report.kind === 'empty') return { tone: 'bad', text: L('verdict_empty') };
    if (report.kind === 'text') return { tone: 'bad', text: L('verdict_not_archive', { kind: L('as_' + (report.textKind || 'text')) }) };
    if (report.kind === 'unknown') return { tone: 'bad', text: L('verdict_unknown') };
    if (!report.issues.length) return { tone: 'good', text: L('verdict_healthy') };
    return { tone: 'warn', text: L('verdict_damaged') };
  }

  function issueLine(i) {
    switch (i.code) {
      case 'signature_broken': return L('issue_signature_broken');
      case 'junk_prefix': return L('issue_junk_prefix', { bytes: fmtSize(i.bytes) });
      case 'no_directory': return L('issue_no_directory');
      case 'directory_broken': return i.listed != null
        ? L('issue_directory_counts', { listed: i.listed, found: i.found })
        : L('issue_directory_broken');
      case 'truncated': return i.missing ? L('issue_truncated_by', { bytes: fmtSize(i.missing) }) : L('issue_truncated');
      case 'encrypted': return L('issue_encrypted');
      case 'renamed': return L('issue_renamed', { actual: esc(i.actual), claimed: esc(i.claimed) });
      case 'not_an_archive': return L('issue_not_an_archive', { kind: L('as_' + (i.as || 'text')) });
      case 'unknown_format': return L('issue_unknown_format');
      case 'headers_damaged': return L('issue_headers_damaged');
      case 'data_damaged': return L('issue_data_damaged');
      case 'cannot_open': return L('issue_cannot_open');
      case 'empty': return L('issue_empty');
      default: return i.code;
    }
  }

  function renderCard(job, idx) {
    var r = job.report;
    var v = r ? verdictOf(r) : { tone: 'warn', text: L('diagnosing') };
    var h = '<div class="arf-card" data-job="' + idx + '">';
    h += '<div class="arf-head"><div class="arf-verdict arf-' + v.tone + '">' + esc(v.text) + '</div>';
    h += '<div class="arf-file">' + esc(job.name) + (job.volumes ? ' · ' + L('volumes_n', { n: job.volumes }) : '') + '</div></div>';

    if (r) {
      h += '<div class="arf-facts">';
      if (r.label) h += '<span><b>' + esc(r.label) + '</b></span>';
      h += '<span>' + fmtSize(r.size) + '</span>';
      if (r.entries) h += '<span>' + L('entries_n', { n: r.entries }) + '</span>';
      h += '</div>';
      if ((r.issues && r.issues.length) || (job.missingParts && job.missingParts.length)) {
        h += '<ul class="arf-issues">';
        if (job.missingParts && job.missingParts.length) h += '<li>' + L('issue_missing_parts', { list: esc(job.missingParts.join(', ')) }) + '</li>';
        for (var i = 0; i < r.issues.length; i++) h += '<li>' + issueLine(r.issues[i]) + '</li>';
        h += '</ul>';
      }
      if (r.preview) h += '<pre class="arf-preview">' + esc(r.preview) + '</pre>';
      if (v.tone === 'good') {
        h += '<div class="arf-good-note">' + L('healthy_note') + ' <a href="' + (window.__EXTRACTOR_URL || '/archive-extractor') + '">' + L('open_in_extractor') + '</a></div>';
      }
    }
    /* Encrypted entries are dead weight without the key, and the diagnosis already
     * knows they are there — so ask right where the problem is named, instead of
     * leaving the user with "some entries are encrypted" and no way to act. */
    if (r && r.issues && r.issues.some(function (i) { return i.code === 'encrypted'; })) {
      h += '<div class="arf-pass"><input type="password" class="lg-input arf-pass-input" autocomplete="off" '
        + 'placeholder="' + esc(L('password_placeholder')) + '" aria-label="' + esc(L('password_placeholder')) + '">'
        + '<span class="arf-pass-hint">' + esc(L('password_hint')) + '</span></div>';
    }
    h += '<div class="arf-progress" hidden><div class="arf-progress-text"></div>'
      + '<div class="arf-bar-wrap"><div class="arf-bar"></div></div></div>';
    h += '<div class="arf-result" hidden></div>';
    h += '</div>';
    return h;
  }

  function renderAll() {
    var h = '';
    for (var i = 0; i < jobs.length; i++) h += renderCard(jobs[i], i);
    cardsEl.innerHTML = h;
    updateActions();
  }

  function cardEl(idx) { return cardsEl.querySelector('.arf-card[data-job="' + idx + '"]'); }

  function anyRepairable() {
    return jobs.some(function (j) {
      return j.report && j.report.issues && j.report.issues.length &&
        j.report.kind !== 'empty' && j.report.kind !== 'text' && j.report.kind !== 'unknown';
    });
  }

  function updateActions() {
    var btn = el('#arfRepairBtn');
    if (!btn) return;
    var can = anyRepairable() && !busy;
    btn.hidden = !anyRepairable();
    btn.disabled = !can;
    var folderBtn = el('#arfRepairFolderBtn');
    if (folderBtn) {
      folderBtn.hidden = !anyRepairable() || typeof window.showDirectoryPicker !== 'function';
      folderBtn.disabled = !can;
    }
    el('#arfCancelBtn').hidden = !busy;
    /* Show the wall against the real cost the moment the queue is known, not only
     * when the button is pressed — a refused press with no pixel change is the
     * failure mode the shared component was rebuilt to avoid. */
    if (window.__toolLimit && window.__toolLimit.precheck && anyRepairable()) {
      window.__toolLimit.precheck(SLUG, jobs.filter(function (j) { return j.report && j.report.issues.length; }).map(function (j) { return j.files[0]; }));
    }
  }

  // ───────────────────────────────── flow ──────────────────────────────────────
  async function onFiles(files) {
    if (!files || !files.length) return;
    jobs = groupPicked(Array.prototype.slice.call(files)).map(function (j) {
      return { name: j.name, files: j.files, volumes: j.volumes || 0, missingParts: j.missingParts || [], report: null, items: new Map(), done: false };
    });
    emptyEl.hidden = true;
    wsEl.hidden = false;
    /* app.css hides the children of any `*-workspace` container until it carries
     * `.active` — a project-wide convention, and the reason the cards rendered
     * with correct text into a zero-height box until this line existed. */
    wsEl.classList.add('active');
    renderAll();
    ae('picked', { jobs: jobs.length, bytes: jobs.reduce(function (s, j) { return s + j.files[0].size; }, 0) });

    /* ⚠️ Разбор идёт по одному файлу с `await`, а `jobs` переприсваивается,
     * как только человек выберет НОВЫЕ файлы. Старый цикл при этом
     * возобновлялся со своим индексом — и `jobs[i]` уже не существовало:
     * `Cannot read properties of undefined (reading 'files')` (Sentry GW).
     *
     * Снимок + проверка поколения: результат старого выбора не должен ни
     * падать, ни — что хуже — записываться в карточки нового. */
    var mine = jobs;
    for (var i = 0; i < mine.length; i++) {
      if (jobs !== mine) return;   // нас обогнал новый выбор
      try {
        mine[i].report = await client.call('diagnose', {
          files: mine[i].files.map(function (f) { return { name: f.name, file: f }; }),
        });
        stage('diagnosed', { kind: mine[i].report.kind, issues: mine[i].report.issues.map(function (x) { return x.code; }).join(',') });
      } catch (e) {
        if (e && e.code === 'MODULE_WORKER_UNSUPPORTED') {
          // Not the file's fault: «none of the known archive signatures» would be a false verdict.
          mine[i].report = { kind: 'engine', size: mine[i].files[0].size, issues: [] };
        } else {
          mine[i].report = { kind: 'unknown', size: mine[i].files[0].size, issues: [{ code: 'unknown_format' }] };
          failed('diagnose_failed', { msg: String(e && e.message).slice(0, 120) });
        }
      }
      renderAll();
    }
  }

  async function repairAll(toFolder) {
    if (busy) return;
    var todo = [];
    for (var i = 0; i < jobs.length; i++) {
      var r = jobs[i].report;
      if (r && r.issues && r.issues.length && r.kind !== 'empty' && r.kind !== 'text' && r.kind !== 'unknown') todo.push(i);
    }
    if (!todo.length) return;

    /* One unit per SOURCE ARCHIVE. begin() with the batch refuses the whole queue
     * up front if it does not fit the day, billing nothing — and a file already
     * repaired today costs nothing to repair again. */
    var keys = window.__toolLimit ? window.__toolLimit.fileKeys(todo.map(function (i) { return jobs[i].files[0]; })) : null;
    var run = window.__toolLimit ? window.__toolLimit.begin(SLUG, keys) : { commit: function () {}, abort: function () {} };
    if (!run) { ae('daily_limit_hit', { jobs: todo.length }); return; }

    /* Writing straight to a folder streams the result to disk and keeps memory flat,
     * which is what makes a multi-gigabyte archive possible. It is a SEPARATE button
     * on purpose: asking for a folder before the primary action meant that
     * dismissing the picker looked exactly like a dead button — the press did
     * nothing, silently. Cancelling here must still not bill. */
    var dir = null;
    if (toFolder && typeof window.showDirectoryPicker === 'function') {
      try { dir = await window.showDirectoryPicker({ mode: 'readwrite' }); }
      catch (e) { run.abort(); return; }
    }

    busy = true; updateActions();
    var t0 = Date.now();
    var totals = { ok: 0, sound: 0, partial: 0, damaged: 0, bytes: 0 };
    try {
      for (var k = 0; k < todo.length; k++) {
        var idx = todo[k];
        await repairOne(idx, dir, totals);
      }
      var recovered = totals.ok + totals.sound + totals.partial;
      if (recovered > 0) {
        run.commit();
        complete({ files: recovered, ok: totals.ok, partial: totals.partial, damaged: totals.damaged, bytes: totals.bytes, ms: Date.now() - t0, jobs: todo.length });
      } else {
        run.abort();   // nothing came back — the day must not be spent on a miss
        failed('nothing_recovered', { jobs: todo.length });
        toast(L('err_none_recovered'), 'warning');
      }
    } catch (e) {
      run.abort();
      failed('repair_failed', { msg: String(e && e.message).slice(0, 120) });
      toast(L('err_repair') + ' ' + (e && e.message ? e.message : ''), 'error');
    } finally {
      busy = false; updateActions();
    }
  }

  async function repairOne(idx, dir, totals) {
    var job = jobs[idx];
    var card = cardEl(idx);
    var prog = el('.arf-progress', card), ptext = el('.arf-progress-text', card), pbar = el('.arf-bar', card);
    prog.hidden = false;
    ptext.textContent = L('repairing');
    job.items = new Map();
    /* Entry names come from the worker exactly as the archive stores them — a
     * Windows-Explorer zip keeps CP866 bytes, carried as U+DC00+byte. What a
     * person reads, sees in the list and gets on disk is decided here, once per
     * job, the same way the extractor decides it. Without the engine (its script
     * failed to load) the bytes that are not UTF-8 show as U+FFFD rather than as
     * lone surrogates no file system accepts. */
    var names = (window.ArchiveEngine && window.ArchiveEngine.nameReader)
      ? window.ArchiveEngine.nameReader()
      : { read: function (k) { return String(k || '').replace(/[\uDC80-\uDCFF]/g, '\uFFFD'); } };
    var writeErr = 0;

    var onStream = function (d) {
      if (d.stream === 'progress' && d.progress) {
        var p = d.progress;
        var pct = p.total ? Math.min(100, Math.round(p.done / p.total * 100)) : 0;
        pbar.style.width = pct + '%';
        ptext.textContent = L('phase_' + String(p.phase).split(':')[0]) + (p.total ? ' ' + pct + '%' : '');
      } else if (d.stream === 'item' && d.item) {
        var it = d.item;
        var bytes = new Uint8Array(it.bytes);
        var shown = names.read(it.path);
        job.items.set(shown, { path: shown, status: it.status, bytes: dir ? null : bytes, size: bytes.length, from: it.from });
        if (dir) {
          // write immediately and drop the bytes — this is what removes the size wall
          writeToDir(dir, safePath(job.name, shown), bytes).catch(function () { writeErr++; });
        }
        renderResult(idx);
      }
    };

    var pwEl = el('.arf-pass-input', card);
    var res = await client.call('repair', {
      files: job.files.map(function (f) { return { name: f.name, file: f }; }),
      password: pwEl ? pwEl.value : '',
    }, onStream);

    prog.hidden = true;
    job.done = true;
    job.strategies = res && res.strategies;
    job.items.forEach(function (it) {
      totals[it.status === 'resynced' ? 'sound' : it.status] = (totals[it.status === 'resynced' ? 'sound' : it.status] || 0) + 1;
      totals.bytes += it.size;
    });
    job.savedToDir = !!dir;
    job.writeErr = writeErr;
    renderResult(idx);
    stage('repaired', {
      kind: job.report.kind,
      files: job.items.size,
      strategy: (res && res.strategies || []).map(function (s) { return s.label + ':' + s.ok; }).join(','),
    });
  }

  function safePath(archiveName, path) {
    var base = String(archiveName).replace(/\.[^.]+$/, '').replace(/[^\w\-. ()Ѐ-ӿ]/g, '_') || 'recovered';
    var clean = String(path).split('/').filter(function (p) { return p && p !== '.' && p !== '..'; }).join('/');
    return base + '/' + (clean || 'file');
  }

  function renderResult(idx) {
    var job = jobs[idx];
    var card = cardEl(idx);
    if (!card) return;
    var box = el('.arf-result', card);
    var items = Array.from(job.items.values());
    if (!items.length) {
      /* "Nothing came back" is an OUTCOME and has to stay on screen. It used to
       * live only in a toast that fades: the card silently returned to the
       * diagnosis and the user was left wondering whether anything ran at all. */
      if (!job.done) { box.hidden = true; return; }
      box.hidden = false;
      var enc = job.report && job.report.issues && job.report.issues.some(function (i) { return i.code === 'encrypted'; });
      box.innerHTML = '<div class="arf-summary arf-none">' + esc(L('err_none_recovered')) + '</div>'
        + (enc ? '<div class="arf-good-note">' + esc(L('none_hint_password')) + '</div>' : '');
      return;
    }
    box.hidden = false;

    var counts = { ok: 0, sound: 0, resynced: 0, partial: 0, damaged: 0 };
    var bytes = 0;
    items.forEach(function (i) { counts[i.status]++; bytes += i.size; });

    var h = '<div class="arf-summary">' + L('summary', { n: items.length, size: fmtSize(bytes) });
    var bits = [];
    if (counts.ok) bits.push(L('summary_ok', { n: counts.ok }));
    if (counts.sound + counts.resynced) bits.push(L('summary_sound', { n: counts.sound + counts.resynced }));
    if (counts.partial) bits.push(L('summary_partial', { n: counts.partial }));
    if (counts.damaged) bits.push(L('summary_damaged', { n: counts.damaged }));
    if (bits.length) h += ' — ' + bits.join(', ');
    h += '</div>';

    if (job.done) {
      h += '<div class="arf-save">';
      if (job.savedToDir) h += '<span class="arf-saved">' + L('saved_to_folder') + (job.writeErr ? ' (' + L('write_errors', { n: job.writeErr }) + ')' : '') + '</span>';
      else {
        /* A .docx / .xlsx / .epub / .apk IS a zip. Handing back loose word/document.xml
         * is not what the person came for — they want the document to open again. Since
         * the recovered entries are already in hand, repacking them under the original
         * extension gives back a FILE THAT WORKS. Found in QA on a broken .docx. */
        var kin = zipKin(job.name);
        if (kin) h += '<button type="button" class="lg-btn arf-repack">' + esc(L('btn_save_repacked', { ext: kin })) + '</button>';
        h += '<button type="button" class="' + (kin ? 'lg-btn lg-btn-ghost' : 'lg-btn') + ' arf-zip">' + esc(L('btn_save_zip')) + '</button>';
      }
      h += '</div>';
    }

    // A long list is unusable without a way to narrow it (1200 rows measured).
    if (items.length > 25) {
      h += '<div class="arf-filter"><input type="search" class="lg-input arf-q" placeholder="' + esc(L('filter_placeholder')) + '" aria-label="' + esc(L('filter_placeholder')) + '">'
        + '<label class="arf-only"><input type="checkbox" class="arf-only-bad"> ' + esc(L('filter_problems_only')) + '</label></div>';
    }

    h += '<ul class="arf-files">';
    items.sort(function (a, b) { return a.path < b.path ? -1 : 1; });
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      h += '<li data-name="' + esc(it.path.toLowerCase()) + '" data-bad="' + (it.status === 'ok' || it.status === 'sound' ? '0' : '1') + '">'
        + '<span class="arf-name" title="' + esc(it.path) + '">' + esc(it.path) + '</span>'
        + statusChip(it.status)
        + '<span class="arf-size">' + fmtSize(it.size) + '</span>'
        + (job.savedToDir ? '' : '<button type="button" class="lg-btn lg-btn-ghost lg-btn-sm arf-one" data-path="' + esc(it.path) + '">' + esc(L('btn_save_one')) + '</button>')
        + '</li>';
    }
    h += '</ul>';
    box.innerHTML = h;

    var zipBtn = el('.arf-zip', box);
    if (zipBtn) zipBtn.addEventListener('click', function () { saveZip(idx, false); });
    var repackBtn = el('.arf-repack', box);
    if (repackBtn) repackBtn.addEventListener('click', function () { saveZip(idx, true); });
    var q = el('.arf-q', box), onlyBad = el('.arf-only-bad', box);
    var applyFilter = function () {
      var term = (q && q.value || '').trim().toLowerCase();
      var bad = onlyBad && onlyBad.checked;
      var lis = box.querySelectorAll('ul.arf-files li');
      for (var k = 0; k < lis.length; k++) {
        var hitName = !term || lis[k].getAttribute('data-name').indexOf(term) !== -1;
        var hitBad = !bad || lis[k].getAttribute('data-bad') === '1';
        lis[k].hidden = !(hitName && hitBad);
      }
    };
    if (q) q.addEventListener('input', applyFilter);
    if (onlyBad) onlyBad.addEventListener('change', applyFilter);
    var ones = box.querySelectorAll('.arf-one');
    for (var k = 0; k < ones.length; k++) {
      ones[k].addEventListener('click', function () {
        var p = this.getAttribute('data-path');
        var it = job.items.get(p);
        if (it && it.bytes) saveBlob(new Blob([it.bytes]), p.split('/').pop() || 'file');
      });
    }
  }

  function saveBlob(blob, name) {
    if (window.__downloadFile) window.__downloadFile(blob, name);
    else { var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = name; a.click(); }
  }

  /* Containers that ARE a zip underneath: repacking the recovered parts under the
   * same extension hands back a file the original program can open again. */
  /* Plain `.zip` is deliberately NOT here: repacking one would put a second button
   * next to "download everything as one ZIP" that does exactly the same thing —
   * two identical actions with different labels, spotted on the iPhone screenshot. */
  var ZIP_KIN = ['docx', 'xlsx', 'pptx', 'odt', 'ods', 'odp', 'epub', 'jar', 'apk', 'war', 'whl', 'nupkg', 'crx'];
  function zipKin(name) {
    var m = String(name || '').toLowerCase().match(/\.([a-z0-9]+)$/);
    return (m && ZIP_KIN.indexOf(m[1]) !== -1) ? m[1] : '';
  }

  function saveZip(idx, repack) {
    var job = jobs[idx];
    var items = Array.from(job.items.values()).filter(function (i) { return i.bytes; });
    if (!items.length) return;
    if (!window.fflate) { toast(L('err_repair'), 'error'); return; }
    var chunks = [];
    var zip = new window.fflate.Zip(function (err, dat) { if (dat) chunks.push(dat); });
    for (var i = 0; i < items.length; i++) {
      var pt = new window.fflate.ZipPassThrough(items[i].path);
      zip.add(pt); pt.push(items[i].bytes, true);
    }
    zip.end();
    var base = String(job.name).replace(/\.[^.]+$/, '') || 'recovered';
    var kin = repack ? zipKin(job.name) : '';
    var fname = kin ? (base + '-fixed.' + kin) : (base + '-recovered.zip');
    saveBlob(new Blob(chunks, { type: kin && kin !== 'zip' ? 'application/octet-stream' : 'application/zip' }), fname);
    ae(repack ? 'saved_repacked' : 'saved_zip', { files: items.length, kin: kin || 'zip' });
  }

  async function writeToDir(dirHandle, path, bytes) {
    /* Имя внутри архива — НЕ обязательно имя, которое примет файловая система.
       Замер 9 дней: 238 из 240 отказов распаковки — `getFileHandle … Name is
       not allowed`, то есть главная причина провала была не в формате архива
       и не в пароле, а в символах имени. `split('/').filter(Boolean)` снимал
       только пустые сегменты: `:` `?` `*` `<` `>` `|` `"`, управляющие символы,
       хвостовые точки, имена устройств (CON/NUL/COM1) и разделитель `\` из
       ZIP-ов, собранных на Windows, доходили до ФС как есть.
       __fsSafePath меняет ТОЛЬКО непринимаемое: `.gitignore`, двойные пробелы
       и кириллица остаются как были (проверено). */
    var sp = (window.__fsSafePath ? window.__fsSafePath.safePath(path, 'file')
                                  : { parts: path.split('/').filter(Boolean).slice(0, -1),
                                      name: path.split('/').filter(Boolean).pop(), changed: false });
    var dir = dirHandle;
    for (var i = 0; i < sp.parts.length; i++) dir = await dir.getDirectoryHandle(sp.parts[i], { create: true });
    var fh = await dir.getFileHandle(sp.name, { create: true });
    var w = await fh.createWritable();
    await w.write(bytes);
    await w.close();
    if (window.__deliveredToDisk) window.__deliveredToDisk(sp.name, bytes, 'folder');
    return sp.changed;
  }

  function reset() {
    client.kill();
    jobs = []; busy = false;
    cardsEl.innerHTML = '';
    wsEl.hidden = true;
    wsEl.classList.remove('active');
    emptyEl.hidden = false;
    var drop = document.getElementById('arfDrop');
    try { if (drop && drop.__uploaderReset) drop.__uploaderReset(); } catch (e) {}
  }

  // ─────────────────────────────────── init ────────────────────────────────────
  function init() {
    root = el('.arf-root');
    if (!root) return;
    emptyEl = el('.arf-empty', root);
    wsEl = el('.arf-workspace', root);
    cardsEl = el('.arf-cards', root);
    resetBtn = el('#arfResetBtn');

    var drop = document.getElementById('arfDrop');
    if (drop) drop.addEventListener('tool-uploader:file', function (e) {
      var picked = (e.detail && e.detail.files) ? Array.prototype.slice.call(e.detail.files)
                 : ((e.detail && e.detail.file) ? [e.detail.file] : []);
      if (picked.length) onFiles(picked);
    });

    /* Accept an archive handed over from /archive-extractor. That tool's telemetry
     * is the reason this one exists: 93 of its 97 errors in 30 days were "this
     * archive will not open", and a dead end there should be one click from here,
     * not a re-pick of a file the browser already has. */
    try {
      if (window.__DiskImage && window.__DiskImage.Handoff) {
        window.__DiskImage.Handoff.consume().then(function (rec) {
          if (rec && rec.file) { ae('handoff_in', { from: rec.sourceSlug || '' }); onFiles([rec.file]); }
        }).catch(function () {});
      }
    } catch (e) {}

    el('#arfRepairBtn').addEventListener('click', function () { repairAll(false); });
    var folderBtn = el('#arfRepairFolderBtn');
    if (folderBtn) folderBtn.addEventListener('click', function () { repairAll(true); });
    el('#arfCancelBtn').addEventListener('click', function () {
      client.cancel();
      setTimeout(function () { client.kill(); busy = false; updateActions(); }, 400);
      ae('cancelled', {});
    });
    if (resetBtn) resetBtn.addEventListener('click', reset);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
